import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { bidsBackend } from './bids.backend';
import { bidsReducer } from './bids.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('bids', bidsReducer),
    BackendModule.forFeature('bids', bidsBackend),
  ],
})
export class DatastoreBidsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/bids/bids.module.ts